import React from 'react';
import { SimpleTooltip } from '../ui/tooltip';
import { cn } from '../../lib/utils';

const HINT_TOOLTIP_CLASS = 'max-w-64 whitespace-normal';

// A real button so the explanation opens on keyboard focus and tap, not only
// on hover; the sr-only copy gives screen readers the same explanation.
export function HintTrigger({
  hint,
  className,
  children,
}: {
  hint: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <SimpleTooltip content={hint} contentClassName={HINT_TOOLTIP_CLASS}>
      <button
        type="button"
        className={cn(
          'focus-visible:outline-ring cursor-help rounded-sm focus-visible:outline-2',
          className,
        )}
      >
        {children}
        <span className="sr-only">{hint}</span>
      </button>
    </SimpleTooltip>
  );
}
